import { render, staticRenderFns } from "./SignInCpf.vue?vue&type=template&id=01ffa5df&scoped=true"
import script from "./SignInCpf.vue?vue&type=script&lang=js"
export * from "./SignInCpf.vue?vue&type=script&lang=js"
import style0 from "./SignInCpf.vue?vue&type=style&index=0&id=01ffa5df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ffa5df",
  null
  
)

export default component.exports